import { useRef, useMemo } from "react"
import { useInView } from "framer-motion"

import { slideUp } from "animations/slideUp"

import { useConsole } from "contexts/Console"

import generateModularBlocks from "utils/generateModularBlocks"
import generateBackground from "utils/generateBackground"

import { getGradient } from "components/articles/common"

import FigCaption from "components/figcaption/FigCaption"
import Video from "components/media/VideoCLD"

import { Root, VideoContent, Content } from "./style"

export default function VideoText({
  className,
  texts,
  video_cld: video,
  order,
  text_width,
  video_width,
  background_color,
  title_gradient,
  chapo_gradient,
  noButton,
  fig_caption,
  animation,
  ...props
}) {
  const console = useConsole()

  const modularBlocks = useMemo(() => generateModularBlocks(texts, { console }), [])

  const rvideo = useRef()

  const cssStyle = background_color ? generateBackground(background_color) : {}

  const titleGradient = title_gradient?.colors ? getGradient(title_gradient.colors) : null
  const chapoGradient = chapo_gradient?.colors ? getGradient(chapo_gradient.colors) : null

  const textContRef = useRef()
  const isInView = useInView(textContRef, { margin: "100% 0% 0% 0%" })
  const prefersReducedMotion = process.browser && document.documentElement.classList.contains("prefers-reduced-motion")
  const maskAnim = animation === "mask"

  console.verbose("================================", props, maskAnim)
  let imageSizes = "100vw"
  switch (video_width) {
    case "l":
      imageSizes = "84vw, (min-width: 48rem) 80vw"
      break
    case "m":
      imageSizes = "84vw, (min-width: 48rem) 70vw"
      break
    case "s":
      imageSizes = "84vw, (min-width: 48rem) 50vw"
      break
  }

  return (
    <Root
      className={`${className} order-${order} width-media-${!video_width ? "xl" : video_width} width-text-${!text_width ? "xl" : text_width}`}
      order={order}
      style={{
        ...cssStyle,
        "--title-gradient": titleGradient,
        "--chapo-gradient": chapoGradient,
      }}
    >
      <VideoContent className={`width-${!video_width ? "xl" : video_width} dark-theme`} maskAnim={maskAnim} isInView={prefersReducedMotion ? true : isInView}>
        <Video ref={rvideo} noButton={noButton} autoPlay {...video} sizes={imageSizes} />
        {fig_caption?.caption?.length ? <FigCaption {...fig_caption} /> : null}
      </VideoContent>

      <Content
        className={`width-${!text_width ? "xl" : text_width}`}
        ref={textContRef}
        variants={slideUp}
        initial='hidden'
        animate={prefersReducedMotion ? "show" : isInView ? "show" : "hide"}
      >
        {modularBlocks}
      </Content>
    </Root>
  )
}
